export function timeAgo(dateStr, t, lang = 'ru') {
  if (!dateStr) return '';
  // SQLite хранит UTC без 'Z' — добавляем чтобы браузер не трактовал как локальное время
  // Если строка — только дата (YYYY-MM-DD), добавляем T12:00:00Z (полдень UTC) чтобы избежать сдвига дня
  let normalized;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    normalized = dateStr + 'T12:00:00Z';
  } else {
    normalized = /Z|[+-]\d{2}:\d{2}$/.test(dateStr) ? dateStr : dateStr.replace(' ', 'T') + 'Z';
  }
  const diff = Math.floor((Date.now() - new Date(normalized).getTime()) / 1000);

  if (t) {
    if (diff < 60)   return t('notifications.justNow');
    if (diff < 3600) return `${Math.floor(diff / 60)} ${t('notifications.minutesAgo')}`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} ${t('notifications.hoursAgo')}`;
    const d = Math.floor(diff / 86400);
    if (d < 7)  return `${d} ${t('notifications.daysAgo')}`;
    if (d < 30) return `${Math.floor(d / 7)} ${t('notifications.weeksAgo')}`;
    return new Date(normalized).toLocaleDateString(lang === 'en' ? 'en-GB' : 'ru-RU', { day: 'numeric', month: 'short' });
  }

  // Fallback без i18n (русский)
  if (diff < 60)   return 'только что';
  if (diff < 3600) return `${Math.floor(diff / 60)} мин назад`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ч назад`;
  const d = Math.floor(diff / 86400);
  if (d < 7)  return `${d} дн назад`;
  if (d < 30) return `${Math.floor(d / 7)} нед назад`;
  return new Date(normalized).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
}
